import React, { useContext } from 'react';

import { FormattedMessage } from 'react-intl';
import { config } from '@xingternal/hops';

import { BodyCopy } from '@xingternal/typography';
import SelectList, { SelectListOption } from '@xingternal/malt-select-list';
import { ErrorContext } from '@xingternal/pages-page-error';
import {
  EditContext,
  usePageContext,
  ReportButton,
} from '@xingternal/pages-common';

import styles from './List.css';

type RenderEditorOptionsProps = {
  globalId?: string;
  ctaType?: string;
};

type ListProps = {
  closePopUp: () => void;
  sharePage: () => void;
  ctaType: string;
};

const List = ({ sharePage, closePopUp, ctaType }: ListProps) => {
  const { isEditor } = useContext(EditContext);
  const { pageContext } = usePageContext();
  const { showError } = useContext(ErrorContext);

  const { globalId } = pageContext;

  return (
    <>
      <BodyCopy noMargin size={'small'} className={styles.moreMenuTitle}>
        <FormattedMessage
          id={'EP_CHOOSE_ACTION'}
          defaultMessage={'EP_CHOOSE_ACTION'}
        />
      </BodyCopy>
      <span data-testid={'HEADER_MORE_ACTIONS_LIST'}>
        <SelectList className={styles.listWrapper}>
          <SelectListOption
            className={styles.listItem}
            onClick={() => sharePage()}
          >
            <span data-testid={'SHARE_PAGE'}>
              <BodyCopy
                noMargin
                fontWeight={'bold'}
                size={'small'}
                className={styles.link}
              >
                <FormattedMessage
                  id={'EP_SHARE_PAGE'}
                  defaultMessage={'EP_SHARE_PAGE'}
                />
              </BodyCopy>
            </span>
          </SelectListOption>
          {!isEditor && (
            <SelectListOption className={styles.listItem}>
              <span data-testid={'REPORT_PAGE'}>
                <ReportButton
                  authorUrn={pageContext?.globalId}
                  targetUrn={globalId}
                  onSuccess={closePopUp}
                  onError={() =>
                    showError({
                      message: 'EP_GENERIC_FEEDBACK_ERROR',
                    })
                  }
                >
                  <BodyCopy noMargin size={'small'} className={styles.link}>
                    <FormattedMessage
                      id={'EP_REPORT_PAGE'}
                      defaultMessage={'EP_REPORT_PAGE'}
                    />
                  </BodyCopy>
                </ReportButton>
              </span>
            </SelectListOption>
          )}
          {isEditor && (
            <RenderEditorOptions globalId={globalId} ctaType={ctaType} />
          )}
        </SelectList>
      </span>
    </>
  );
};

const RenderEditorOptions = ({
  globalId,
  ctaType,
}: RenderEditorOptionsProps) => (
  <>
    <SelectListOption
      className={styles.listItem}
      onClick={() =>
        window.open(
          `${config.apiHost}/xam/aac/?entity_urn=${globalId}&asset_urn=${globalId}`,
          '_blank'
        )
      }
    >
      <span data-testid={'EP_PROMOTE_PAGE'}>
        <BodyCopy
          noMargin
          fontWeight={'bold'}
          size={'small'}
          className={styles.link}
        >
          <FormattedMessage
            id={'EP_PROMOTE_PAGE'}
            defaultMessage={'EP_PROMOTE_PAGE'}
          />
        </BodyCopy>
      </span>
    </SelectListOption>
    {ctaType === 'follow' && (
      <SelectListOption
        className={styles.listItem}
        onClick={() => window.open(`${config.apiHost}/brandmanager/`, '_blank')}
      >
        <span data-testid={'ADMINISTRATE_PAGE'}>
          <BodyCopy
            noMargin
            fontWeight={'bold'}
            size={'small'}
            className={styles.link}
          >
            <FormattedMessage
              id={'EP_ADMINISTRATE_PAGE'}
              defaultMessage={'EP_ADMINISTRATE_PAGE'}
            />
          </BodyCopy>
        </span>
      </SelectListOption>
    )}
    {ctaType === 'follow' && (
      <SelectListOption
        className={styles.listItem}
        onClick={() =>
          window.open('https://community.xing.com/de/s/', '_blank')
        }
      >
        <span data-testid={'HELP_CENTER'}>
          <BodyCopy
            noMargin
            fontWeight={'bold'}
            size={'small'}
            className={styles.link}
          >
            <FormattedMessage
              id={'EP_HELP_CENTER'}
              defaultMessage={'EP_HELP_CENTER'}
            />
          </BodyCopy>
        </span>
      </SelectListOption>
    )}
  </>
);

export default List;
